import { motion } from "framer-motion";

const EASE = [0.19, 1, 0.22, 1];

// Masked, line-by-line reveal for editorial headlines.
export const MaskedLines = ({ lines, className = "", delay = 0, stagger = 0.12 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Generic scroll-triggered reveal wrapper.
export const Reveal = ({ children, className = "", delay = 0, y = 34, as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-12% 0px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Reveal that clip-wipes a block into view (used on images).
export const RevealMask = ({ children, className = "", delay = 0 }) => (
  <div className={`overflow-hidden ${className}`}>
    <motion.div
      initial={{ scale: 1.14, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 1.3, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  </div>
);

export { EASE };
